/*
 * Server-offset clock (spec 3.10): offset = serverNow - Date.now() captured on
 * each server response; "now" = Date.now() + offset. Used by HoldTimer and by
 * the My Events ticket card's EditGuest cutoff. Never a client-started timer.
 */
import { useEffect, useState } from "react";

export function clockOffsetMs(serverNowIso: string | null | undefined) {
  if (!serverNowIso) return 0;
  const t = Date.parse(serverNowIso);
  return Number.isNaN(t) ? 0 : t - Date.now();
}

/** Re-renders every `tickMs` with the server-corrected time. */
export function useServerNow(serverNowIso: string | null | undefined, tickMs = 1000) {
  const [offset, setOffset] = useState(() => clockOffsetMs(serverNowIso));
  const [now, setNow] = useState(() => Date.now() + offset);
  useEffect(() => {
    const next = clockOffsetMs(serverNowIso);
    setOffset(next);
    setNow(Date.now() + next);
  }, [serverNowIso]);
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now() + offset), tickMs);
    return () => clearInterval(id);
  }, [offset, tickMs]);
  return now;
}
